import React from 'react'
import PropTypes from 'prop-types'
import { Tabs } from 'antd'

import 'styles/AntOverrides.css'
import 'styles/ChecComponents.css'

const ChecTabs = ({
  tabs,
  activeKey,
  onTabClick,
  tabPanes,
  defaultActiveKey,
  renderTabBar,
}) => (
  <Tabs
    tabs={tabs}
    defaultActiveKey={defaultActiveKey}
    activeKey={activeKey}
    onTabClick={onTabClick}
    renderTabBar={renderTabBar}
  >
    {tabPanes.map(({ tab, content, key, disabled }) => (
      <Tabs.TabPane key={key || tab} disabled={disabled} tab={tab}>
        {content}
      </Tabs.TabPane>
    ))}
  </Tabs>
)

ChecTabs.propTypes = {
  tabs: PropTypes.bool,
  activeKey: PropTypes.string,
  defaultActiveKey: PropTypes.string,
  onTabClick: PropTypes.func,
  renderTabBar: PropTypes.func,
  tabPanes: PropTypes.array,
}

export default ChecTabs
